import api from "./api";

/**
 * Cliente HTTP dos setores (Department) do tenant. Mesma instância Axios
 * (`api`, com baseURL `/api` e token via interceptor) usada pelo restante do
 * app. Base do recurso: `/tenants/departments`.
 *
 * Contrato do backend (F2.3):
 *  - GET    /tenants/departments                     → lista de setores
 *  - POST   /tenants/departments        { name, color? }
 *  - PATCH  /tenants/departments/:id    { name?, color?, isActive? }
 *  - DELETE /tenants/departments/:id
 *  - POST   /tenants/departments/:id/members         { memberId }  (TenantMember.id)
 *  - DELETE /tenants/departments/:id/members/:memberId
 */
const BASE = "/tenants/departments";

export const listDepartments = () => api.get(BASE);

export const createDepartment = ({ name, color }) =>
  api.post(BASE, color ? { name, color } : { name });

export const updateDepartment = (id, payload) =>
  api.patch(`${BASE}/${id}`, payload);

export const deleteDepartment = (id) => api.delete(`${BASE}/${id}`);

export const addDepartmentMember = (id, memberId) =>
  api.post(`${BASE}/${id}/members`, { memberId });

export const removeDepartmentMember = (id, memberId) =>
  api.delete(`${BASE}/${id}/members/${memberId}`);
